import React from 'react';

export default function FuelLogsTab({ vehicleId }) {
    return (
        <div>
            <h2 className="text-lg font-bold mb-4">Fuel Logs</h2>
            <p>Fuel tracking for vehicle ID: {vehicleId} (Coming Soon)</p>
        </div>
    );
}
